import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface Program {
  _id: string;
  name: string;
  description?: string;
  status?: "active" | "inactive" | string;
  parentDepartmentId?: string;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

export type ProgramsResponse = {
  success: boolean;
  message: string;
  data: Program[];
};

const fetchPrograms = async (): Promise<ProgramsResponse> =>
  (await customAxios.get<ProgramsResponse>("/programs/")).data;

export const useGetPrograms = () =>
  useQuery<ProgramsResponse, AxiosError>(["programs"], fetchPrograms, {
    onError: (error) =>
      showNotification({
        title: "Error Loading Programs",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to load programs",
        color: "red",
      }),
    staleTime: 0,
    retry: 1,
    refetchOnMount: "always",
  });
